const foreign_labor_uischema = {
  view: "main",
  title: "Foreign Labor Recruiter Profiles",
  entity: "Foreign Labor Recruiters",
  linkBack: {
    name: "Back to Profiles",
    link: "/dashboard/profiles/",
  },
  button: {
    name: "New Recruiter",
    style: "default",
  },
};

export default foreign_labor_uischema;
